module.exports = __webpack_public_path__ + "static/media/bank.2da35fb7.png";